import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { store } from './store';
import theme from './theme';
import LoadingSpinner from './components/LoadingSpinner';
import WalletSyncEffects from './components/WalletSyncEffects';
import MarketingLayout from './components/MarketingLayout';
import DappLayout from './components/DappLayout';
import ClaimLayout from './components/ClaimLayout';
import { I18nProvider } from './i18n';

// Pages
import AuthCallback from './pages/AuthCallback';
import AuthError from './pages/AuthError';
import Login from './pages/Login';

// 레이지 로딩으로 컴포넌트 로드
const Home = lazy(() => import('./pages/Home'));
const Transfer = lazy(() => import('./pages/Transfer'));
const TransferLink = lazy(() => import('./pages/TransferLink'));
const SenderTransferDetail = lazy(() => import('./pages/SenderTransferDetail'));
const Profile = lazy(() => import('./pages/Profile'));
const Claim = lazy(() => import('./pages/Claim'));
const Guide = lazy(() => import('./pages/Guide'));
const Demo = lazy(() => import('./pages/Demo'));
const Status = lazy(() => import('./pages/Status'));
const AdminReconcile = lazy(() => import('./pages/AdminReconcile'));
const AdminTransfers = lazy(() => import('./pages/AdminTransfers'));

function App() {
  return (
    <Provider store={store}>
      <I18nProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <WalletSyncEffects />
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route element={<MarketingLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/guide" element={<Guide />} />
                  <Route path="/demo" element={<Demo />} />
                  <Route path="/status" element={<Status />} />
                </Route>
                <Route element={<ClaimLayout />}>
                  <Route path="/claim/:claimToken" element={<Claim />} />
                </Route>
                <Route element={<DappLayout />}>
                  <Route path="/transfer" element={<Transfer />} />
                  <Route path="/transfer/:linkId" element={<TransferLink />} />
                  <Route path="/transfer/:linkId/manage" element={<SenderTransferDetail />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/auth" element={<Login />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                  <Route path="/auth/error" element={<AuthError />} />
                  <Route path="/admin/reconcile" element={<AdminReconcile />} />
                  <Route path="/admin/transfers" element={<AdminTransfers />} />
                </Route>
              </Routes>
            </Suspense>
          </Router>
        </ThemeProvider>
      </I18nProvider>
    </Provider>
  );
}

export default App; 